import React, { useEffect, useMemo } from 'react';
import { StyleSheet, ScrollView, View } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import * as Location from 'expo-location';
import { useNavigation } from '@react-navigation/native';

import TripSearchWidget from '../../components/TripSearchWidget/TripSearchWidget';
import { setSearchInput, tripSearch, setGeolocation } from '../../store/actions/search';
import { getNearestAirportFromCoords } from '../../services/api/search.service';
import { openAlert } from '../../store/actions/alert';
import { validateTripSearch, isBXservice, isOneWayTrip } from '../../utils/search.utils';
import { Color, CommonStyles } from '../../styles';
import { clearSelectedCarCache } from '../../store/actions/car';
import { selectedCarComponents } from '../../store/selectors/car.selector';
import { setIsBXCurrencyCulture } from '../../store/actions/auth';
import { Modals } from '../../constants/ScreenNames';

import { getAAServiceTypeOptions } from './AAHomeScreen';
import { clearSeatSelected } from '../../store/actions/seat';

const AASearchScreen = (props) => {
  const selectedCar = useSelector(selectedCarComponents);
  const dispatch = useDispatch();
  const navigation = useNavigation();
  const searchTripLoading = useSelector((s) => s.search.tripResultsLoading);
  const user = useSelector((state) => state && state.auth && state.auth.user);
  const isLeisureAllowed = user ? user.IsLeisureAllowed : false;
  const { serviceType } = props?.route?.params || {};
  const options = useMemo(() => getAAServiceTypeOptions(user), [user]);

  const onSearchHandler = async (searchInput, searchInputState) => {
    const validationResult = validateTripSearch(searchInput);
    if (validationResult.isFailed) {
      dispatch(openAlert({ message: validationResult.msg }));
    } else {
      await dispatch(clearSelectedCarCache(searchInput, selectedCar));
      dispatch(clearSeatSelected());
      await dispatch(setSearchInput(searchInput, searchInputState));
      if (isBXservice(searchInputState.serviceType) && isOneWayTrip(searchInput.airRequestType)) {
        navigation.navigate(Modals.OneWayBXAlertModal, {});
        return;
      }
      dispatch(tripSearch());
    }
  };

  useEffect(() => {
    async function getLocationAsync() {
      try {
        const obj = await Location.requestForegroundPermissionsAsync();
        if (obj?.status === 'granted') {
          const location = await Location.getCurrentPositionAsync({});
          const latitude = location.coords.latitude;
          const longitude = location.coords.longitude;
          const locationRequest = {
            Latitude: latitude,
            Longitude: longitude,
          };
          const airport = await getNearestAirportFromCoords(locationRequest);
          dispatch(setGeolocation(latitude, longitude, airport?.Code));
        }
      } catch (ex) {
        __DEV__ && console.info('get location failed', ex);
      }
    }
    getLocationAsync();
    dispatch(setIsBXCurrencyCulture(serviceType));
  }, [dispatch, serviceType]);

  return (
    <View style={CommonStyles.flex1}>
      <ScrollView contentContainerStyle={styles.scrollViewContainer}>
        <TripSearchWidget
          onSearch={onSearchHandler}
          initState={{ serviceType, isLeisureAllowed, options }}
          loading={searchTripLoading}
        />
      </ScrollView>
    </View>
  );
};

export const styles = StyleSheet.create({
  scrollViewContainer: {
    flexGrow: 1,
    backgroundColor: Color.background,
  },
});

export default AASearchScreen;
